export enum DeliverableOptionValues {
  YES_RESUBMIT_FOR_REVIEW = 'Yes - Resubmit for review',
  NO = 'No',
}
